import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-4">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            关于赤裸特工的疑问
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            快速了解赤裸特工的常见问题与解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-200/50 transition-colors duration-200"
              >
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 pr-8">
                  {item.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}